import {find as _find, each as _each} from 'lodash';
import {Utils} from './Utils'
import {StringUtils} from "./StringUtils";
import {UrlInfo} from "./CommonTypes";
const url = require('url');

export type IHashItem = {
    name: string;
    value: string
};

/**
 * Uri helper methods
 */
export class UriHelper {

    /**
     * Gets game key from URI query string key 'game'
     * @returns {string} game code
     */
    public static getGameKey(): string {
        var uriObj = URI();
        var query = uriObj.query(true);
        var gameKey = query['game'];
        if (Utils.isNullOrUndefined(gameKey)) {
            gameKey = uriObj.segment(0);
        }

        return gameKey;
    }

    /**
     * Sets @timestamp query string into specified source @url.
     * @param url - source url where to put @timestamp query string value
     * @param timestamp - value of timestamp
     * @param timeStampKey - key name for timestamp query string (default is '_t')
     * @returns {string} url string with updated timestamp part in query string.
     */
    public static setTimeStamp(url: string, timestamp: string = null, timeStampKey: string = '_t'): string {
        var uri = URI(url);
        timeStampKey = Utils.valueOrDefault(timeStampKey, '_t');
        timestamp = Utils.valueOrDefault(timestamp, Date.now().toString());
        uri.setQuery(timeStampKey, timestamp);
        return uri.toString();
    }

    /**
     * Gets flag if packets mode is enabled or not, determine it from query string parameter 'packets'.
     * @param uriObj - Uri query object (from @Utils.getURIQuery) or null to get actual URI query.
     * @returns {boolean} true if packets mode is enabled or false if not.
     */
    public static getPacketsMode(uriObj?: Object): boolean {
        uriObj = Utils.valueOrDefault(uriObj, Utils.getURIQuery());
        return Utils.valueOrDefault(uriObj['packets'], false);
    }

    public static getPacketSetName(uriObj?: Object): string {
        uriObj = Utils.valueOrDefault(uriObj, Utils.getURIQuery());
        return Utils.valueOrDefault(uriObj['packetSet'], null);
    }

    public static updateHashGroupValue(name: string, value: string): void {
        var groups = this.getHashGroups();
        var item: IHashItem = _find(groups, group => StringUtils.equals(group.name, name, true));
        if (Utils.isNullOrUndefined(item)) {
            item = {
                name: name,
                value: value
            };
            groups.push(item);
        } else {
            item.value = value;
        }

        this.updateHash(groups);
    }

    public static updateHash(groups: Array<IHashItem>): void {
        var fragment: string = '';
        for (var i = 0; i < groups.length; i++) {
            var group = groups[i];
            fragment += `${group.name}=${group.value}`;
            if (i + 1 < groups.length) {
                fragment += '&';
            }
        }

        var oldhash = location.hash;
        var hash = URI().fragment(fragment).hash();

        try {
            if (history && history.replaceState) {
                history.replaceState(null, null, hash);
            } else {
                location.hash = hash;
            }
        } catch(e) { // in case call to 'history.replaceState' fails
            if (DEBUG) {
                console.log(`UrlHelper.updateHash failed on update hash with 'history.replaceState', manually setting location.hash!`);
            }
            location.hash = hash;
        }

        console.log(`Update location hash to: "${hash}" (old: "${oldhash}")`);
    }

    public static getHashGroupValue(name: string, defaultValue: string): string {
        var groups = this.getHashGroups();
        if (groups.length > 0) {
            var item = _find(groups, group => StringUtils.equals(group.name, name, true));
            return item ? item.value : defaultValue;
        }
    }

    public static getHashGroups(): Array<IHashItem> {
        var result: Array<IHashItem> = [];
        var fragment = URI().fragment();
        if (fragment) {
            var groups = fragment.split('&');

            _each(groups, group => {
                var groupVals = group.split('=', 2);
                var name = groupVals.length > 0 ? groupVals[0] : '';
                var value = groupVals.length > 1 ? groupVals[1] : '';
                if (!StringUtils.isNullOrEmpty(name)) {
                    result.push({
                        name: name,
                        value: value
                    });
                }
            });
        }

        return result;
    }

    public static parseUrl(urlStr: string, parseQueryString: boolean = false, slashesDenoteHost: boolean = false): UrlInfo {
        return url.parse(urlStr, parseQueryString, slashesDenoteHost) as UrlInfo;
    }

    public static formatUrl(urlInfo: UrlInfo): string {
        return url.format(urlInfo) as string;
    }

    public static resolveUrl(from: string, to: string): string {
        return url.resolve(from, to) as string;
    }
}


const isBrowser = typeof window !== 'undefined';

if (isBrowser) {
    (window as any)['URI'] = URI;
}


/** WEBPACK FOOTER **
 ** ./Engine/Utils/UriHelper.ts
 **/